import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px !important;
  gap: 6px;
  width: 100%;

  .inputBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
  }

  .error {
    font-size: 12px;
    font-family: Montserrat;
    color: #fb264b;
    font-weight: 500;
    line-height: 12px;
  }

  input,
  textarea {
    background: #ffffff;

    &::placeholder {
      font-size: 16px;
      line-height: 22px;
      font-weight: normal;
      font-family: Nunito, sans-serif;
    }
  }
`;
